import getSearchedLocation from '@location/selectors/getSearchedLocation';
import { getResultsRoute } from '@services/routes.service';
import { pushPage } from '@shared/actions';

const navigateToResults = (location, filters) => (dispatch, getState) => {
  let useLocation = location;
  if (!useLocation) useLocation = getSearchedLocation(getState());

  const route = filters
    ? getResultsRoute({ ...useLocation, ...filters })
    : getResultsRoute(useLocation);

  dispatch(pushPage(route));
};

export default navigateToResults;
